export default {"src":"/_next/static/image/public/images/flags/flag_505.d8eb5e4210fb96aeac36dced33a9b23e.svg","height":16,"width":24};